// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"70":"d48e8c76","242":"30947808","433":"b97914cf","939":"f12325be"}[chunkId] + ".css";
};